import React from "react";
import { ArrowDownRight } from "lucide-react";

const PILLARS = ["Memory", "Commerce", "Intelligence", "Governance", "Mastery"];

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-[170px] md:pt-[210px] pb-24 md:pb-32 px-6 md:px-10 overflow-hidden"
    >
      {/* Decorative serif letter */}
      <div
        aria-hidden
        className="absolute -top-10 right-[-4%] md:right-[-2%] font-serif-display text-[28vw] md:text-[20vw] leading-none text-black/[0.045] select-none pointer-events-none float-slow"
      >
        M
      </div>

      <div className="grid grid-cols-12 gap-y-10 relative">
        <div className="col-span-12 md:col-span-2 hidden md:flex items-start">
          <div className="vert-text mt-2">MERA — 01 / 04</div>
        </div>

        <div className="col-span-12 md:col-span-10">
          <div className="flex items-center gap-3 mb-8" data-testid="hero-eyebrow">
            <span className="inline-block w-8 h-px bg-black/40" />
            <span className="font-mono-label text-[11px] text-black/60">
              The Human Ecosystem · Est. 2025
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-serif-display text-[14vw] md:text-[9.5vw] lg:text-[8.4rem] xl:text-[9.5rem] leading-[0.92] tracking-tight"
          >
            Humanity, <span className="italic-accent">powered</span>
            <br />
            by intelligence.
          </h1>

          <div className="mt-10 grid grid-cols-12 gap-6">
            <p
              data-testid="hero-subhead"
              className="col-span-12 md:col-span-6 text-[17px] md:text-[18px] leading-relaxed text-black/65"
            >
              MERA builds AI-native products for the full arc of human potential.
              Tools that remember what matters, protect what is earned, connect
              what is siloed, and compound what is learned — built for people
              first, ready for institutions from day one.
            </p>

            <div className="col-span-12 md:col-span-5 md:col-start-8 flex flex-col gap-5">
              <a
                href="#foundry"
                data-testid="hero-cta-foundry"
                className="mera-btn self-start"
              >
                <span className="dot" />
                Explore the Ecosystem
                <ArrowDownRight size={16} strokeWidth={1.5} />
              </a>
              <a
                href="#ecosystem"
                data-testid="hero-cta-manifesto"
                className="font-mono-label text-[11px] text-black/60 hover:text-black transition-colors self-start inline-flex items-center gap-2"
              >
                Read the manifesto
                <span aria-hidden>↓</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom rule + five pillars */}
      <div
        data-testid="hero-pillar-strip"
        className="mt-24 md:mt-32 grid grid-cols-2 md:grid-cols-5 border-t border-black/10 pt-6 gap-y-3"
      >
        {PILLARS.map((p) => (
          <div
            key={p}
            data-testid={`hero-pillar-${p.toLowerCase()}`}
            className="font-mono-label text-[10px] text-black/55"
          >
            ◦ {p}
          </div>
        ))}
      </div>
    </section>
  );
};
